import { yupResolver } from "@hookform/resolvers/yup";
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Grid,
    IconButton,
    Radio,
    RadioGroup,
    useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Close from "@material-ui/icons/Close";
import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { Constant } from "../../Constant";
import useCustomYup from "../../CustomYup/CustomYup";
import {
    dataURItoBlob,
    getDataByOpenIdAndAccessToken,
    isNotEmpty,
} from "../../Utils";
import CustomFileInput from "../../inputComponent/CustomFileInput/CustomFileInput";
import { getForm } from "../../redux/selector";
import IamsmartSigningButton from "../IamsmartSigningButton/IamsmartSigningButton";
import SignatureCanvasDialog from "../SignatureCanvasDialog/SignatureCanvasDialog";
import Form102SignDialog from "./Form102SignDialog";
import Form104SignDialog from "./Form104SignDialog";

const useStyles = makeStyles({
    root: {
        width: "85%",
        height: "100%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
});

const iamSmartBtnStyle = makeStyles((theme) => ({
    root: {
        borderRadius: 6,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        textTransform: "none",
        "&:hover": {
            backgroundColor: theme.palette.primary.dim,
        },
    },
}));

const signatureDialogTitleStyle = makeStyles((theme) => ({
    root: {
        fontSize: "1rem",
    },
}));

function SigningDialog({ formOpen, onSign, onClose = () => {} }) {
    const [asHkid, setAsHkid] = useState("");
    const dispatch = useDispatch();
    const storageIamsmartProfile = sessionStorage?.getItem("iamsmartProfile")
        ? JSON.parse(sessionStorage?.getItem("iamsmartProfile"))
        : {};

    let openID = storageIamsmartProfile?.openID;
    let accessToken = storageIamsmartProfile?.accessToken;

    let iasTokenMap = sessionStorage?.getItem("iasTokenMap")
        ? JSON.parse(sessionStorage?.getItem("iasTokenMap"))
        : {};
    console.log("SigningDialog iasTokenMap=====", JSON.stringify(iasTokenMap));
    let iasOpenID = iasTokenMap?.openID;
    console.log("SigningDialog iasOpenID 11111111111=====", iasOpenID);
    const iasAccessToken = iasTokenMap?.accessToken;

    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");
    const navigate = useNavigate();
    const { hkidYup } = useCustomYup();

    const { formId, referenceId, status } = useSelector(getForm());
    const [signCanvasOpen, setSignCanvasOpen] = useState(false);
    const [form102SignDialog, setForm102SignDialog] = useState(false);
    const [form104SignDialog, setForm104SignDialog] = useState(false);
    const iamSmartList = Constant.onlyIamSmartSigningList;
    const { digitSignOnlyList, excludeIamSmartSigningList } = Constant;
    const isIamSmartOnly = iamSmartList.includes(formId);
    const isDigitSignOnly = digitSignOnlyList.includes(formId);
    const isExcludeIamSmartSigning =
        excludeIamSmartSigningList.includes(formId);

    let yupSchema;

    // if (isNotEmpty(openID) || isNotEmpty(iasOpenID)){
    //     yupSchema = yup.object().shape({
    //         //hkid: hkidYup,
    //     });
    // }else {
    //     yupSchema = yup.object().shape({
    //         hkid: hkidYup,
    //     });
    // }
    yupSchema = yup.object().shape({
        //hkid: hkidYup,
    });

    const { register, handleSubmit, watch, control, formState, clearErrors } =
        useForm({
            defaultValues: {
                signingMethod: isIamSmartOnly ? "I" : "D", // D: digital; U: upload; I: iAMSmart
                hkid: "",
                file: [],
            },
            mode: "onBlur",
            resolver: yupResolver(yupSchema),
        });

    const onUpdateSigning = (key, val) => {
        onSign(key, val)
            .then(() => {
                onClose();
            })
            .catch((error) => {
                console.error("Signing error:", error);
            });
    };

    const onUploadSignature = (file) => {
        console.log("onUploadSignature", file);
        return onUpdateSigning("U", file[0]);
    };

    const onDigitalSigning = (dataURL) => {
        return onUpdateSigning(
            "D",
            new File([dataURItoBlob(dataURL)], "digitalSigning.png")
        );
    };

    const onIAMSmartSigning = (signature, cert, hashCode) => {
        return onUpdateSigning("I", { signature, cert, hashCode });
    };

    const onSubmit = () => {};
    const onError = () => {};

    const signingMethod = watch("signingMethod");
    const iamSmartBtnClasses = iamSmartBtnStyle();
    const signatureDialogTitleClasses = signatureDialogTitleStyle();

    const hkic = watch("hkid").split("(")[0];
    const errors = formState.errors;

    console.log("SigningDialog iasOpenID 222222222=====", iasOpenID);
    console.log("SigningDialog asHkid 222222222=====", asHkid);
    if (
        (isNotEmpty(openID) || isNotEmpty(iasOpenID)) &&
        asHkid === "GTest1111"
    ) {
        //当有iasOpenID 或者 openID 要清除假的身份证号 让代码进入useEffect中获取真正的身份证号码
        setAsHkid("");
    }
    useEffect(() => {
        console.log("SigningDialog iasOpenID 3333333=====", iasOpenID);
        if (isNotEmpty(iasOpenID)) {
            console.log("SigningDialog iasOpenID 444444444=====", iasOpenID);
            const paramMap = {
                idNumber: { iasName: "idNo" },
            };
            let rnData = getDataByOpenIdAndAccessToken(
                iasOpenID,
                iasAccessToken,
                paramMap,
                dispatch
            );
            rnData.then(
                (result) => {
                    console.log("result==========", result); // 输出: Promise resolved successfully!
                    let strData = jwtDecode(result)?.profile;
                    let asHkidOrign = strData?.idNo?.Identification;
                    setAsHkid(asHkidOrign);
                    console.log(
                        "SigningDialog getDataByOpenIdAndAccessToken anon  asHkid=====%%%%%%%%%%",
                        asHkid
                    );
                },
                (error) => {
                    console.log("11111111***********************");
                    console.error(error);
                }
            );
        } else if (isNotEmpty(openID)) {
            const paramMap = {
                idNumber: { iasName: "idNo" },
            };
            let rnData = getDataByOpenIdAndAccessToken(
                openID,
                accessToken,
                paramMap,
                dispatch
            );
            rnData.then(
                (result) => {
                    console.log("result==========", result); // 输出: Promise resolved successfully!
                    let strData = jwtDecode(result)?.profile;
                    let asHkidOrign = strData?.idNo?.Identification;
                    setAsHkid(asHkidOrign);
                },
                (error) => {
                    console.log("222222***********************");
                    console.error(error);
                }
            );
        } else {
            setAsHkid("GTest1111"); // 第一次anonsign当设置一个假的身份证号码欺骗组件IamsmartSigningButton，在IamsmartLoginedSigningButton中再获取真正的身份证号码
        }
    }, [asHkid]);
    console.log(
        "SigningDialog getDataByOpenIdAndAccessToken both asHkid=====%%%%%%%%%%%",
        asHkid
    );
    return (
        <form onSubmit={handleSubmit(onSubmit, onError)}>
            <Dialog
                disableEscapeKeyDown={true}
                aria-labelledby="signature-dialog"
                open={formOpen}
            >
                <DialogTitle id="signature-dialog-title">
                    <Grid classes={{ root: signatureDialogTitleClasses.root }}>
                        {t("common.signing.method")}
                        <IconButton aria-label="cancel" onClick={onClose}>
                            <Close />
                        </IconButton>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <Grid
                        container
                        spacing={0}
                        direction="column"
                        alignItems="center"
                        justify="center"
                    >
                        <Controller
                            control={control}
                            name="signingMethod"
                            render={({ field }) => (
                                <RadioGroup
                                    aria-label="signing"
                                    value={field.value}
                                    onChange={(e) => {
                                        field.onChange(e.target.value);
                                        if (e.target.value === "L") {
                                            if (formId === "Form104") {
                                                setForm104SignDialog(true);
                                            } else {
                                                setForm102SignDialog(true);
                                            }
                                        }
                                    }}
                                >
                                    {formId === "Form104" ? (
                                        <>
                                            <FormControlLabel
                                                key={"digitalSigning"}
                                                value={"D"}
                                                control={
                                                    <Radio color="primary" />
                                                }
                                                label={t(
                                                    "common.signingMethod.esigning"
                                                )}
                                            />
                                            <FormControlLabel
                                                key={"uploadSignature"}
                                                value={"U"}
                                                control={
                                                    <Radio color="primary" />
                                                }
                                                label={t(
                                                    "common.signingMethod.uploadSigning"
                                                )}
                                            />
                                            <FormControlLabel
                                                key={"iamSmart"}
                                                value={"I"}
                                                control={
                                                    <Radio color="primary" />
                                                }
                                                label={t(
                                                    "common.signingMethod.iamsmart"
                                                )}
                                            />
                                            <FormControlLabel
                                                key={"signLater"}
                                                value={"L"}
                                                control={
                                                    <Radio color="primary" />
                                                }
                                                label={t(
                                                    "common.signingMethod.signLater"
                                                )}
                                            />
                                            <Form104SignDialog
                                                formOpen={form104SignDialog}
                                                onConfirm={() => {
                                                    setForm104SignDialog(false);
                                                }}
                                            />
                                        </>
                                    ) : isIamSmartOnly &&
                                      formId === "Form102" ? (
                                        <>
                                            <FormControlLabel
                                                key={"iamSmart"}
                                                value={"I"}
                                                control={
                                                    <Radio color="primary" />
                                                }
                                                label={t(
                                                    "common.signingMethod.iamsmart"
                                                )}
                                            />
                                            <FormControlLabel
                                                key={"signLater"}
                                                value={"L"}
                                                control={
                                                    <Radio color="primary" />
                                                }
                                                label={t(
                                                    "common.signingMethod.signLater"
                                                )}
                                            />
                                            <Form102SignDialog
                                                formOpen={form102SignDialog}
                                                onConfirm={() => {
                                                    setForm102SignDialog(false);
                                                }}
                                            />
                                        </>
                                    ) : isIamSmartOnly ? (
                                        <>
                                            <FormControlLabel
                                                key={"iamSmart"}
                                                value={"I"}
                                                control={
                                                    <Radio color="primary" />
                                                }
                                                label={t(
                                                    "common.signingMethod.iamsmart"
                                                )}
                                            />
                                        </>
                                    ) : isDigitSignOnly ? (
                                        <FormControlLabel
                                            key={"digitalSigning"}
                                            value={"D"}
                                            control={<Radio color="primary" />}
                                            label={t(
                                                "common.signingMethod.esigning"
                                            )}
                                        />
                                    ) : isExcludeIamSmartSigning ? (
                                        <>
                                            <FormControlLabel
                                                key={"digitalSigning"}
                                                value={"D"}
                                                control={
                                                    <Radio color="primary" />
                                                }
                                                label={t(
                                                    "common.signingMethod.esigning"
                                                )}
                                            />
                                            <FormControlLabel
                                                key={"uploadSignature"}
                                                value={"U"}
                                                control={
                                                    <Radio color="primary" />
                                                }
                                                label={t(
                                                    "common.signingMethod.uploadSigning"
                                                )}
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <FormControlLabel
                                                key={"digitalSigning"}
                                                value={"D"}
                                                control={
                                                    <Radio color="primary" />
                                                }
                                                label={t(
                                                    "common.signingMethod.esigning"
                                                )}
                                            />
                                            <FormControlLabel
                                                key={"uploadSignature"}
                                                value={"U"}
                                                control={
                                                    <Radio color="primary" />
                                                }
                                                label={t(
                                                    "common.signingMethod.uploadSigning"
                                                )}
                                            />
                                            <FormControlLabel
                                                key={"iamSmart"}
                                                value={"I"}
                                                control={
                                                    <Radio color="primary" />
                                                }
                                                label={t(
                                                    "common.signingMethod.iamsmart"
                                                )}
                                            />
                                        </>
                                    )}
                                </RadioGroup>
                            )}
                        />
                        {signingMethod == "D" && (
                            <>
                                <Button
                                    variant="contained"
                                    classes={{ root: iamSmartBtnClasses.root }}
                                    onClick={() => {
                                        setSignCanvasOpen(true);
                                    }}
                                    style={
                                        i18n.language === "en"
                                            ? {
                                                  padding: "12px 22px",
                                                  width: "12rem",
                                              }
                                            : {
                                                  padding: "12px 22px",
                                                  width: "9rem",
                                              }
                                    }
                                >
                                    {t("common.esigning")}
                                </Button>
                                <SignatureCanvasDialog
                                    isOpen={signCanvasOpen}
                                    onClose={() => {
                                        setSignCanvasOpen(false);
                                    }}
                                    onDigitalSign={onDigitalSigning}
                                />
                            </>
                        )}
                        {signingMethod == "U" && (
                            <CustomFileInput
                                control={control}
                                name="file"
                                fileType=".jpg, .jpeg, .png"
                                label={t("common.uploadFile")}
                                onUpload={onUploadSignature}
                            />
                        )}
                        {signingMethod == "I" && (
                            <>
                                <IamsmartSigningButton
                                    onSign={onIAMSmartSigning}
                                    hkic={asHkid}
                                    handleSubmit={handleSubmit}
                                />
                            </>
                        )}
                        {/*{signingMethod == "I"  && isEmpty(openID) && isEmpty(iasOpenID) && (*/}
                        {/*    <>*/}
                        {/*        <Box mb={6}>*/}
                        {/*            <CustomHKID*/}
                        {/*                control={control}*/}
                        {/*                label={t("common.signing.ID")}*/}
                        {/*                name="hkid"*/}
                        {/*                displayColon={false}*/}
                        {/*                showError={false}*/}
                        {/*                clearErrors={clearErrors}*/}
                        {/*            />*/}
                        {/*        </Box>*/}

                        {/*        <ErrorMsg message={errors?.hkid?.message} />*/}
                        {/*        <IamsmartSigningButton*/}
                        {/*            onSign={onIAMSmartSigning}*/}
                        {/*            hkic={hkic}*/}
                        {/*            handleSubmit={handleSubmit}*/}
                        {/*        />*/}
                        {/*    </>*/}
                        {/*)}*/}

                        {signingMethod == "L" && (
                            <>
                                <Button
                                    variant="contained"
                                    classes={{ root: iamSmartBtnClasses.root }}
                                    onClick={() => {
                                        onUpdateSigning("L");
                                    }}
                                    style={
                                        i18n.language === "en"
                                            ? {
                                                  padding: "12px 22px",
                                                  width: "12rem",
                                              }
                                            : {
                                                  padding: "12px 22px",
                                                  width: "9rem",
                                              }
                                    }
                                >
                                    {t("common.signingMethod.signLater")}
                                </Button>
                            </>
                        )}
                    </Grid>
                </DialogContent>
            </Dialog>
        </form>
    );
}
export default SigningDialog;
